import styled from "styled-components";

export default styled.span`
    text-shadow: 0px 0px 4px #fff; 
`